import { useMemo } from 'react';
import { differenceInDays, subDays } from 'date-fns';

interface PreviousPeriodDates {
  previousStartDate: Date;
  previousEndDate: Date;
}

export const usePreviousPeriodDates = (
  startDate: Date | null,
  endDate: Date | null
): PreviousPeriodDates | null => {
  return useMemo(() => {
    if (!startDate || !endDate) {
      return null;
    }

    // Calculate current period length in days
    const periodLengthInDays = differenceInDays(endDate, startDate);
    
    // Calculate previous period dates
    const previousEndDate = subDays(startDate, 1);
    const previousStartDate = subDays(previousEndDate, periodLengthInDays);

    return {
      previousStartDate,
      previousEndDate,
    };
  }, [startDate, endDate]);
};
